module.exports = __webpack_public_path__ + "static/media/doremi_00245.fc356b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/doremi_00245.png
// module id = 257
// module chunks = 0